import React from "react";
import MultistepForm from "./components/multistep-form/MultistepForm";


export default function Atkvaedi() {
  return <MultistepForm />;
}
